import {
  FocusContext,
  useFocusable,
} from '@noriginmedia/norigin-spatial-navigation'
import cx from 'classnames'
import React, { useEffect } from 'react'
import { platformTransitionStyle } from '../../../../shared/helpers'
import { useSidePanel } from './SidePanelProvider'
import SidePanelItem from './SidePanelItem'
import { SIDE_PANEL_ITEMS } from './utils'

const { HOME, LIVESTREAM, SHOWS, MY_LIST, MY_STATION, SEARCH, SETTINGS } =
  SIDE_PANEL_ITEMS

export const SidePanel = () => {
  const { ref, focusKey, hasFocusedChild } = useFocusable({
    trackChildren: true,
    focusKey: 'SIDE_PANEL',
  })
  const {
    setIsSidePanelFocused,
    activeItem,
    isSidePanelOpened,
    hasFullWidthBackground,
  } = useSidePanel()

  useEffect(() => setIsSidePanelFocused(hasFocusedChild), [hasFocusedChild])

  return (
    <FocusContext.Provider value={focusKey}>
      <div
        style={{
          transition: platformTransitionStyle('transform 500ms linear'),
        }}
        className={cx('side-panel', {
          'side-panel--closed': !isSidePanelOpened,
          'side-panel__full-width-background': hasFullWidthBackground,
        })}
        ref={ref}
      >
        <ul className="side-panel__list">
          <SidePanelItem
            title={HOME.title}
            to={HOME.to}
            active={HOME.to === activeItem}
          />
          <SidePanelItem
            title={LIVESTREAM.title}
            to={LIVESTREAM.to}
            active={LIVESTREAM.to === activeItem}
          />
          <SidePanelItem
            title={SHOWS.title}
            to={SHOWS.to}
            active={SHOWS.to === activeItem}
          />
          <SidePanelItem
            title={MY_LIST.title}
            to={MY_LIST.to}
            active={MY_LIST.to === activeItem}
          />
          <SidePanelItem
            title={MY_STATION.title}
            to={MY_STATION.to}
            active={MY_STATION.to === activeItem}
          />
        </ul>
        <hr className="side-panel__separator" />
        <ul className="side-panel__list">
          <SidePanelItem
            title={SEARCH.title}
            to={SEARCH.to}
            active={SEARCH.to === activeItem}
          />
          <SidePanelItem
            title={SETTINGS.title}
            to={SETTINGS.to}
            active={SETTINGS.to === activeItem}
          />
        </ul>
      </div>
    </FocusContext.Provider>
  )
}

export default SidePanel
